import { render, staticRenderFns } from "./bread_crumbs.vue?vue&type=template&id=669f22ed&"
import script from "./bread_crumbs.vue?vue&type=script&lang=js&"
export * from "./bread_crumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports